import { render, staticRenderFns } from "./SectionArea.vue?vue&type=template&id=6305da62"
import script from "./SectionArea.vue?vue&type=script&lang=ts"
export * from "./SectionArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports